module.exports = __webpack_public_path__ + "static/media/Couto.3888d80a.png";